import React from 'react'
import PropTypes from 'prop-types'
import styles from './ProfileRightSidebar.module.scss'

// right sidebar slot
export default function ProfileRightSidebar({ children }) {
  return <aside className={styles.sidebar}>{children}</aside>
}

ProfileRightSidebar.propTypes = {
  children: PropTypes.node,
}
